<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="editor-keyboard-hint d-flex flex-column ga-3">
    <div class="d-flex align-center ga-2">
      <kbd class="editor-keyboard-hint__key">{{ t("updates.keyboard-hint.enter") }}</kbd>
      <span class="editor-keyboard-hint__label">{{ t("updates.keyboard-hint.new-line") }}</span>
    </div>

    <div class="d-flex align-center ga-2">
      <div class="d-flex align-center ga-1">
        <kbd class="editor-keyboard-hint__key">{{ t("updates.keyboard-hint.shift") }}</kbd>
        <span class="editor-keyboard-hint__label">+</span>
        <kbd class="editor-keyboard-hint__key">{{ t("updates.keyboard-hint.enter") }}</kbd>
      </div>
      <span class="editor-keyboard-hint__label">{{ t("updates.keyboard-hint.new-paragraph") }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.editor-keyboard-hint {
  &__key {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    min-width: 20px;
    padding: 0 4px;
    border: 1px solid $grey-lighten-2;
    border-radius: 4px;
    background-color: $grey-lighten-4;
    color: $grey-navy;
    font-family: inherit;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }

  &__label {
    color: $grey-darken-1;
    font-size: 13px;
    line-height: 18px;
    white-space: nowrap;
  }
}
</style>
